
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/marketplace",
      function () {
        return require("private-next-pages/about/marketplace/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/marketplace"])
      });
    }
  